import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import '../../assets/scss/components/_invoice.scss';
import {
  BookingDetailsData,
  BookingInvoiceItem,
  getBookingContainerDetailsAsync,
  getBookingTravelvatsAsync,
  getBookingvatsAsync,
  selectBookingDetails,
  selectBookingDetailsLoadingStatus,
  selectBookingTravelVatReport,
  selectBookingVatReport,
  setBookingContainer,
} from './bookingsSlice';
import {
  getSiteDetailsAsync,
  selectSiteDetails,
} from '../offices/OfficesSlice';

function BookingCompensationInvoice() {
  const { locale = 'fi' } = useParams();
  const backLinkUrl = '/bookings/search-bookings';
  const params = useParams();
  const state = useLocation();
  const dispatch = useAppDispatch();
  const bookingContainer = useAppSelector(selectBookingDetails);
  const siteDetails = useAppSelector(selectSiteDetails);
  const bookingDetailsLoadingStatus = useAppSelector(
    selectBookingDetailsLoadingStatus,
  );
  const bookingVats = useAppSelector(selectBookingVatReport);
  const [invoiceData, setInvoiceData] = useState<BookingInvoiceItem>({
    id: '',
    referenceNumber: 0,
    discriminator: '',
    number: 0,
    invoiceDate: '',
    entryDate: '',
    dueDate: '',
    booking: '',
    delayFeeP: 0,
    compensationInvoiceId: '',
  } as BookingInvoiceItem);
  const [bookingData, setBookingData] = useState<BookingDetailsData>({
    id: '',
    createdAt: '',
    payerId: '',
    authorId: '',
    bookingType: 0,
    bookingNumber: 0,
    payerFirstName: '',
    payerLastName: '',
    payerAccountNumber: '',
    accommodationId: '',
    isCancelled: false,
    bookingOrderItems: [],
    customerBookingNotes: [],
    ownerBookingNotes: [],
    officerBookingNotes: [],
    netPrice: 0,
    finalBillPrice: 0,
    finalBillPriceWithoutVat: 0,
    finalBillPriceVat: 0,
    advanceBillPrice: 0,
    advanceBillPriceVat: 0,
    advanceBillPriceWithoutVat: 0,
    bookingContainerId: '',
    invoicingLanguageLocale: '',
    bookingInvoiceItems: [],
    errors: [],
    webShopCustomer: null,
    isAllowedToCancel: false,
    isAllowedToEdit: false,
    isAddOnBooking: false,
    reasonOfCancellation: '',
    extraBookingResponses: [],
    accommodationReclamationText: '',
    preliminaryBookingDueDate: null,
  } as BookingDetailsData);

  const initFetch = useCallback(() => {
    // console.debug('initFetch', locale, params);
    dispatch(getBookingvatsAsync(params.bookingId));
    dispatch(getBookingTravelvatsAsync(params.bookingId));
    if (params.bookingId !== 'search') {
      dispatch(getBookingContainerDetailsAsync(params.bookingId)).then(res => {
        if (res.payload === null) {
          dispatch(setBookingContainer(null));
        }
      });
    }
  }, [dispatch, params.bookingId]);
  const bookingTravelVats = useAppSelector(selectBookingTravelVatReport);
  const travelVatLinesFinal = bookingTravelVats?.vatItems
    .filter(i => i.finalNetto > 0)
    .map(item => (
      <tr>
        <td>{item.vatP}</td>
        <td style={{ textAlign: 'right' }}>
          {-(item.finalNetto + item.advanceNetto).toFixed(2)}
        </td>
        <td style={{ textAlign: 'right' }}>
          {-(item.finalVatAmount + item.advanceVatAmount).toFixed(2)}
        </td>
        <td style={{ textAlign: 'right' }}>
          {-(item.finalTotal + item.advanceTotal).toFixed(2)}
        </td>
      </tr>
    ));
  const travelAgentVatLinesFinal = bookingTravelVats?.agentVatItems
    .filter(i => i.finalNetto > 0)
    .map(item => (
      <tr>
        <td>{item.vatP}</td>
        <td style={{ textAlign: 'right' }}>
          {-(item.finalNetto + item.advanceNetto).toFixed(2)}
        </td>
        <td style={{ textAlign: 'right' }}>
          {-(item.finalVatAmount + item.advanceVatAmount).toFixed(2)}
        </td>
        <td style={{ textAlign: 'right' }}>
          {-(item.finalTotal + item.advanceTotal).toFixed(2)}
        </td>
      </tr>
    ));
  useEffect(() => {
    initFetch();
  }, [initFetch, params.bookingId]);
  useEffect(() => {
    if (bookingContainer && bookingContainer.bookingResponses) {
      const bookingDataFound = bookingContainer.bookingResponses.filter(br =>
        br.bookingInvoiceItems.filter(
          i => i.number.toString() === params.invoiceId,
        ),
      );
      if (bookingDataFound && bookingDataFound.length > 0) {
        setBookingData(bookingDataFound[0]);
        const invoice = bookingDataFound[0].bookingInvoiceItems.filter(
          i => i.number.toString() === params.invoiceId,
        );
        if (invoice && invoice.length > 0) {
          setInvoiceData(invoice[0]);
          dispatch(getSiteDetailsAsync(invoice[0].siteId));
        }
      }
    }
  }, [bookingContainer]);
  useEffect(() => {
    // console.debug('siteDetails', siteDetails);
  }, [siteDetails]);
  const getInvoiceTitle = () => {
    // console.debug('invoiceData', invoiceData, bookingData);
    if (invoiceData && invoiceData.discriminator.includes('FinalInvoice')) {
      return `LOPPULASKU${params.copy === 'true' ? '(KOPIO)' : ''}`;
    }
    if (invoiceData && invoiceData.discriminator.includes('AdvanceInvoice')) {
      return `ENNAKKOLASKU${params.copy === 'true' ? '(KOPIO)' : ''}`;
    }
    if (
      invoiceData &&
      invoiceData.discriminator.includes('CompensationInvoice')
    ) {
      return `HYVITYSLASKU${params.copy === 'true' ? '(KOPIO)' : ''}`;
    }
    return '';
  };
  const getIsAdvance = () => {
    const compensatedInvoce = bookingData?.bookingInvoiceItems.filter(
      bi =>
        bi.compensationInvoiceId !== null &&
        invoiceData.id !== null &&
        bi.compensationInvoiceId.toUpperCase() === invoiceData.id.toUpperCase(),
    );
    // console.debug('compensatedInvoce', compensatedInvoce);
    if (
      compensatedInvoce &&
      compensatedInvoce.length > 0 &&
      compensatedInvoce[0].discriminator.includes('FinalInvoice')
    ) {
      return false;
    }
    if (
      compensatedInvoce &&
      compensatedInvoce.length > 0 &&
      compensatedInvoce[0].discriminator.includes('AdvanceInvoice')
    ) {
      return true;
    }
    return false;
  };
  const getIsFinal = () => {
    const compensatedInvoce = bookingData?.bookingInvoiceItems.filter(
      bi =>
        bi.compensationInvoiceId !== null &&
        invoiceData.id !== null &&
        bi.compensationInvoiceId.toUpperCase() === invoiceData.id.toUpperCase(),
    );
    // console.debug('compensatedInvoce', compensatedInvoce);
    if (
      compensatedInvoce &&
      compensatedInvoce.length > 0 &&
      compensatedInvoce[0].discriminator.includes('FinalInvoice')
    ) {
      return true;
    }
    if (
      compensatedInvoce &&
      compensatedInvoce.length > 0 &&
      compensatedInvoce[0].discriminator.includes('AdvanceInvoice')
    ) {
      return false;
    }
    return false;
  };
  const linesCareTaker = bookingVats?.careTakerVats?.map(item => (
    <tbody style={{ borderTop: 'solid' }}>
      <tr>
        <td>{item.ownerNameNumber}</td>
      </tr>
      <tr>
        <td>{item.ownerPhone}</td>
      </tr>
      <tr>
        <td>{item.ownerEmail}</td>
      </tr>
    </tbody>
  ));
  const getInvoiceIncludedWithoutVat = () => {
    let sum = 0;
    bookingData?.bookingOrderItems
      .filter(inv => inv.includedInPrice)
      .map(item => {
        sum += item.pricesResponse.finalBillPriceWithoutVat;
        return sum;
      });
    return sum;
  };

  const getInvoiceIncludedVat = () => {
    let sum = 0;
    bookingData?.bookingOrderItems
      .filter(inv => inv.includedInPrice)
      .map(item => {
        sum += item.pricesResponse.finalBillPriceVat;
        return sum;
      });
    return sum;
  };
  const getInvoiceIncluded = () => {
    let sum = 0;
    bookingData?.bookingOrderItems
      .filter(inv => inv.includedInPrice)
      .map(item => {
        sum += item.pricesResponse.finalBillNetPrice;
        return sum;
      });
    return sum;
  };
  const getWithOutVatFinal = () => {
    let sum = 0;
    bookingData?.bookingOrderItems
      .filter(line => !line.itemName.toLowerCase().includes('toimitus'))
      .map(item => {
        sum += item.pricesResponse.finalBillPriceWithoutVat;
        return sum;
      });
    return sum.toFixed(2);
  };
  const getWithOutVatAdvance = () => {
    let sum = 0;
    bookingData?.bookingOrderItems.map(item => {
      sum += item.pricesResponse.advanceBillPriceWithoutVat;
      return sum.toFixed(2);
    });
    return sum.toFixed(2);
  };
  const getVatFinal = () => {
    let sum = 0;
    bookingData?.bookingOrderItems.map(item => {
      sum += item.pricesResponse.finalBillPriceVat;
      return sum;
    });
    return sum.toFixed(2);
  };
  const getVatAdvance = () => {
    let sum = 0;
    bookingData?.bookingOrderItems.map(item => {
      sum += item.pricesResponse.advanceBillPriceVat;
      return sum;
    });
    return sum.toFixed(2);
  };
  const advanceIvoiceLines = bookingData?.bookingOrderItems
    .filter(line => line.pricesResponse.advanceBillPrice > 0)
    .map(item => (
      <tr>
        <td>{item.itemName}</td>
        <td style={{ textAlign: 'center' }}>{item.units}</td>
        <td>
          {new Date(Date.parse(item.startDateTime)).toLocaleDateString('fi-FI')}{' '}
          - {new Date(Date.parse(item.endDateTime)).toLocaleDateString('fi-FI')}
        </td>
        <td style={{ textAlign: 'center' }}>{item.amountOfAdults}</td>
        <td style={{ textAlign: 'center' }}>{item.amountOfChildren}</td>
        <td style={{ textAlign: 'right' }}>
          {item.orderItemType === 0
            ? -item.pricesResponse.advanceBillPriceWithoutVat.toFixed(2)
            : -item.pricesResponse.advanceBillPriceWithoutVat.toFixed(2)}
        </td>
        <td style={{ textAlign: 'right' }}>
          {-item.pricesResponse.advanceBillPriceVat.toFixed(2)}
        </td>
        <td style={{ textAlign: 'right' }}>{item.pricesResponse.vatP}%</td>
        <td style={{ textAlign: 'right' }}>{item.pricesResponse.discount}</td>
        <td style={{ textAlign: 'right' }}>
          {-item.pricesResponse.travelAgencyComission.toFixed(2)}
        </td>
        <td style={{ textAlign: 'right' }}>
          {-item.pricesResponse.advanceBillPrice.toFixed(2)}
        </td>
      </tr>
    ));
  const vatLinesFinal = bookingVats?.vatItems
    .filter(i => i.finalTotal > 0)
    .map(item => (
      <tr>
        <td>{item.vatP}</td>
        <td style={{ textAlign: 'right' }}>{-item.finalNetto}</td>
        <td style={{ textAlign: 'right' }}>{-item.finalVatAmount}</td>
        <td style={{ textAlign: 'right' }}>{-item.finalTotal}</td>
      </tr>
    ));

  const notesLines = bookingData?.customerBookingNotes?.map(item => (
    <tr>
      <td>{item.noteText}</td>
    </tr>
  ));
  const getTotal = () => {
    let sum = 0;
    bookingVats?.vatItems.map(item => {
      sum += item.finalTotal;
      return sum;
    });
    return sum.toFixed(2);
  };
  const vatLinesAdvance = bookingVats?.vatItems
    .filter(i => i.advanceTotal > 0)
    .map(item => (
      <tr>
        <td>{item.vatP}</td>
        <td style={{ textAlign: 'right' }}>{-item.advanceNetto}</td>
        <td style={{ textAlign: 'right' }}>{-item.advanceVatAmount}</td>
        <td style={{ textAlign: 'right' }}>{-item.advanceTotal}</td>
      </tr>
    ));
  // console.debug('vatLinesAdvance', bookingVats.ownerVats);
  const vatLinesOwner = bookingVats?.ownerVats?.map(item => (
    <tbody style={{ borderTop: 'solid' }}>
      <tr>
        <td>{item.ownerNameNumber}</td>
      </tr>
      <tr>
        <td>{item.ownerPhone}</td>
      </tr>
      <tr>
        <td>{item.ownerEmail}</td>
      </tr>
      <table>
        <thead>
          <tr>
            <th style={{ textAlign: 'left' }}>
              <strong>Kohde / palvelut</strong>
            </th>
            <th style={{ textAlign: 'right' }}>
              <strong>Alv %</strong>
            </th>
            <th style={{ textAlign: 'right' }}>
              <strong>Netto</strong>
            </th>
            <th style={{ textAlign: 'right' }}>
              <strong>Alv</strong>
            </th>
            <th style={{ textAlign: 'right' }}>
              <strong>Yhteensä</strong>
            </th>
          </tr>
        </thead>
        {item?.ownerVatItems?.map(vat => (
          <tbody>
            <tr>
              <td style={{ textAlign: 'left', width: '20%' }}>
                {vat.itemNameNumber}
              </td>
              <td style={{ textAlign: 'right' }}>{vat.vatP}</td>
              <td style={{ textAlign: 'right' }}>{vat.netto}</td>
              <td style={{ textAlign: 'right' }}>{vat.vatAmount}</td>
              <td style={{ textAlign: 'right' }}>{vat.total}</td>
            </tr>
          </tbody>
        ))}
      </table>
    </tbody>
  ));
  const ibanLines = siteDetails?.siteBankData.map(item => (
    <div>
      {item.iban}
      <br />
    </div>
  ));
  const bicLines = siteDetails?.siteBankData.map(item => (
    <tr>
      <td>{item.bic}</td>
    </tr>
  ));
  const getFinalInvoicePrice = item => {
    if (item.orderItemType === 0 && !item.includedInPrice) {
      return -(item.pricesResponse.finalBillNetPrice + getInvoiceIncluded());
    }
    if (item.includedInPrice) {
      return 'Sisältyy hintaan';
    }
    return -item.pricesResponse.finalBillNetPrice.toFixed(2);
  };
  const getFinalInvoicePriceWithoutVat = item => {
    if (item.orderItemType === 0 && !item.includedInPrice) {
      return (
        item.pricesResponse.finalBillPriceWithoutVat +
        getInvoiceIncludedWithoutVat()
      ).toFixed(2);
    }
    if (item.includedInPrice) {
      return 'Sisältyy hintaan';
    }
    return item.pricesResponse.finalBillNetPriceWithoutVat.toFixed(2);
  };

  const finalInvoiceLines = bookingData?.bookingOrderItems
    .filter(
      line =>
        !line.itemName.toLowerCase().includes('toimitus') &&
        (line.pricesResponse.finalBillNetPrice > 0 || line.includedInPrice) &&
        line.itemName,
    )
    .map(item => (
      <tr>
        <td>{item.itemName}</td>
        {!item.includedInPrice && (
          <>
            <td style={{ textAlign: 'center' }}>{item.units}</td>
            <td>
              {new Date(Date.parse(item.startDateTime)).toLocaleDateString(
                'fi-FI',
              )}{' '}
              -{' '}
              {new Date(Date.parse(item.endDateTime)).toLocaleDateString(
                'fi-FI',
              )}
            </td>
            <td style={{ textAlign: 'center' }}>{item.amountOfAdults}</td>
            <td style={{ textAlign: 'center' }}>{item.amountOfChildren}</td>
            <td style={{ textAlign: 'right' }}>
              {-getFinalInvoicePriceWithoutVat(item)}
            </td>
            <td style={{ textAlign: 'right' }}>
              {item.orderItemType === 0 &&
                -(
                  item.pricesResponse.finalBillPriceVat +
                  getInvoiceIncludedVat()
                ).toFixed(2)}
              {item.orderItemType !== 0 &&
                -(
                  item.pricesResponse.finalBillNetPriceVat +
                  item.pricesResponse.advanceBillPriceVat
                ).toFixed(2)}
            </td>
            <td style={{ textAlign: 'right' }}>{item.pricesResponse.vatP}%</td>
            <td style={{ textAlign: 'right' }}>
              {-item.pricesResponse.discount.toFixed(2)}
            </td>
            <td style={{ textAlign: 'right' }}>
              {-item.pricesResponse.travelAgencyComission.toFixed(2)}
            </td>
            <td style={{ textAlign: 'right' }}>
              {
                -(
                  item.pricesResponse.finalBillNetPrice + getInvoiceIncluded()
                ).toFixed(2)
              }
            </td>
          </>
        )}
        {item.includedInPrice && (
          <td colSpan={2} style={{ textAlign: 'center' }}>
            Sisältyy hintaan
          </td>
        )}
      </tr>
    ));
  return (
    <div className="invoice-body">
      <Helmet>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>{getInvoiceTitle()}</title>
      </Helmet>
      <div>
        <div className="invoice-container">
          <header className="header">
            <table style={{ width: '100%' }}>
              <thead style={{ display: 'table-header-group' }}>
                <tr>
                  <td style={{ width: '50%' }}>
                    <div className="logo-section">
                      <p className="large">
                        <strong>{siteDetails?.name}</strong>
                        <br />
                        {siteDetails?.postStreetName}
                        {', '}
                        {siteDetails?.postPostCode} {siteDetails?.postCity}
                        <br />
                        {`Sinua palveli: ${bookingData.authorFirstName} ${bookingData.authorLastName}`}
                        <br />
                        {`Sähköposti: ${bookingData.authorEmail ?? ''}`}
                        <br />
                      </p>
                    </div>
                    <div
                      className="recipient-info"
                      style={{ paddingTop: '10px', paddingBottom: '20px' }}
                    >
                      <p>
                        <p>
                          {siteDetails?.siteCustomerName ?? ''} <br />
                          {siteDetails?.siteCustomerAddress ?? ''}
                          <br />
                          {siteDetails?.siteCustomerPostAddress ?? ''}
                        </p>
                      </p>
                    </div>
                  </td>
                  <td style={{ width: '50%' }} valign="top">
                    <div className="invoice-details">
                      <span
                        className="large"
                        style={{
                          display: 'inline-block',
                          paddingBottom: '20px',
                        }}
                      >
                        <strong>{getInvoiceTitle()}</strong>
                      </span>
                      <table>
                        <tbody>
                          <tr>
                            <td className="label" style={{ width: '100px' }}>
                              Päivämäärä:
                            </td>
                            <td>
                              {new Date(
                                Date.parse(invoiceData.entryDate),
                              ).toLocaleDateString('fi-FI')}
                            </td>
                          </tr>
                          <tr>
                            <td className="label">Laskun numero:</td>
                            <td>{invoiceData.number}</td>
                          </tr>
                          <tr>
                            <td className="label">Asiakasnumero:</td>
                            <td>{bookingData.payerAccountNumber}</td>
                          </tr>
                          <tr>
                            <td className="label">Varaustunnus:</td>
                            <td>{bookingData.bookingNumber}</td>
                          </tr>
                          <tr>
                            <td
                              className="label"
                              style={{ paddingTop: '20px' }}
                            >
                              <strong>Eräpäivä:</strong>
                            </td>
                            <td style={{ paddingTop: '20px' }}>
                              <strong>
                                {new Date(
                                  Date.parse(invoiceData.dueDate),
                                ).toLocaleDateString('fi-FI')}
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td className="label">Viivästyskorko:</td>
                            <td>{invoiceData.delayFeeP}%</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </thead>
              <tbody />
            </table>
          </header>
          {/* Invoice Table */}
          <section className="invoice-table">
            <table>
              <thead className="small">
                <tr>
                  <th style={{ width: '220px' }}>Kohde / palvelut</th>
                  <th style={{ textAlign: 'center' }}>Kpl</th>
                  <th style={{ width: '220px' }}>Aika</th>
                  <th style={{ textAlign: 'center' }}>Aik.</th>
                  <th style={{ textAlign: 'center' }}>Lap.</th>
                  <th style={{ textAlign: 'right' }}>Yksikköhinta (alv 0%)</th>
                  <th style={{ textAlign: 'right' }}>Alv</th>
                  <th style={{ textAlign: 'right' }}>Alv%</th>
                  <th style={{ textAlign: 'right' }}>Alennus</th>
                  <th style={{ textAlign: 'right' }}>Provisio</th>
                  <th style={{ textAlign: 'right', width: '110px' }}>
                    Yhteensä (sis. alv)
                  </th>
                </tr>
              </thead>
              <tbody
                style={{
                  borderBottom: 'solid 1px #000000',
                  borderTop: 'solid 1px #000000',
                }}
              >
                {getIsAdvance() && advanceIvoiceLines}
                {getIsFinal() && finalInvoiceLines}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={9} style={{ width: '100%' }} />
                  <td>
                    <strong>Yhteensä</strong>
                  </td>
                  <td style={{ width: '120px', textAlign: 'right' }}>
                    <strong>
                      {getIsFinal() && -bookingData.finalBillPrice}
                      {getIsAdvance() && -bookingData.advanceBillPrice}
                    </strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </section>

          {/* Tax */}
          <section className="taxes">
            <table>
              <tbody>
                <tr>
                  <td style={{ width: '48%' }}>
                    {' '}
                    {notesLines.length > 0 && (
                      <table
                        style={{
                          width: '100%',
                          marginLeft: '0px',
                          marginBottom: '10px',
                          marginTop: '10px',
                          border: 'solid 1px #000000',
                        }}
                      >
                        <thead>
                          <tr
                            style={{
                              width: '200px',
                              textAlign: 'left',
                              border: 'solid 1px #000000',
                            }}
                          >
                            <th colSpan={4}>
                              <strong>Lisätiedot</strong>
                            </th>
                          </tr>
                          <tr>
                            <th style={{ width: '200px', textAlign: 'left' }}>
                              <strong>Tiedote:</strong>
                            </th>
                          </tr>
                        </thead>
                        <tbody>{notesLines}</tbody>
                      </table>
                    )}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '48%' }}>
                    {getIsFinal() &&
                      !bookingData.crossSiteBooking &&
                      travelVatLinesFinal.length > 0 && (
                        <table
                          style={{
                            marginLeft: 'auto',
                            marginBottom: '10px',
                            marginTop: '10px',
                            border: 'solid 1px #000000',
                          }}
                        >
                          <thead>
                            <tr
                              style={{
                                width: '200px',
                                textAlign: 'left',
                                border: 'solid 1px #000000',
                              }}
                            >
                              <th colSpan={4}>
                                <strong>
                                  Matkatoimistoprovisio verokannoittain
                                </strong>
                              </th>
                            </tr>
                            <tr>
                              <th style={{ width: '200px', textAlign: 'left' }}>
                                <strong>Sis.alv.</strong>
                              </th>
                              <th
                                style={{ width: '100px', textAlign: 'right' }}
                              >
                                Netto
                              </th>
                              <th
                                style={{ width: '100px', textAlign: 'right' }}
                              >
                                Alv.
                              </th>
                              <th
                                style={{ width: '100px', textAlign: 'right' }}
                              >
                                Yhteensä
                              </th>
                            </tr>
                          </thead>
                          <tbody>{getIsFinal() && travelVatLinesFinal}</tbody>
                        </table>
                      )}
                    {getIsFinal() &&
                      !bookingData.crossSiteBooking &&
                      travelAgentVatLinesFinal.length > 0 && (
                        <table
                          style={{
                            marginLeft: 'auto',
                            marginBottom: '10px',
                            marginTop: '10px',
                            border: 'solid 1px #000000',
                          }}
                        >
                          <thead>
                            <tr
                              style={{
                                width: '200px',
                                textAlign: 'left',
                                border: 'solid 1px #000000',
                              }}
                            >
                              <th colSpan={4}>
                                <strong>
                                  Matkatkan järjestäjä provisio verokannoittain
                                </strong>
                              </th>
                            </tr>
                            <tr>
                              <th style={{ width: '200px', textAlign: 'left' }}>
                                <strong>Sis.alv.</strong>
                              </th>
                              <th
                                style={{ width: '100px', textAlign: 'right' }}
                              >
                                Netto
                              </th>
                              <th
                                style={{ width: '100px', textAlign: 'right' }}
                              >
                                Alv.
                              </th>
                              <th
                                style={{ width: '100px', textAlign: 'right' }}
                              >
                                Yhteensä
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {getIsFinal() && travelAgentVatLinesFinal}
                          </tbody>
                        </table>
                      )}
                  </td>{' '}
                  <td style={{ width: '4%' }} />
                  <td style={{ width: '48%' }}>
                    <table
                      style={{
                        marginLeft: 'auto',
                        marginBottom: '10px',
                        marginTop: '10px',
                        border: 'solid 1px #000000',
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            width: '200px',
                            textAlign: 'left',
                            border: 'solid 1px #000000',
                          }}
                        >
                          <th colSpan={4}>
                            <strong>Arvonlisävero verokannoittain</strong>
                          </th>
                        </tr>
                        <tr>
                          <th style={{ width: '200px', textAlign: 'left' }}>
                            <strong>Sis.alv.</strong>
                          </th>
                          <th style={{ width: '100px', textAlign: 'right' }}>
                            Netto
                          </th>
                          <th style={{ width: '100px', textAlign: 'right' }}>
                            Alv.
                          </th>
                          <th style={{ width: '100px', textAlign: 'right' }}>
                            Yhteensä
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {getIsFinal() && vatLinesFinal}
                        {getIsAdvance() && vatLinesAdvance}
                      </tbody>
                    </table>
                    <table
                      style={{
                        marginLeft: 'auto',
                        marginBottom: '10px',
                        marginTop: '10px',
                      }}
                    >
                      <thead>
                        <tr>
                          <th style={{ width: '200px', textAlign: 'right' }}>
                            <strong />
                          </th>
                          <th style={{ width: '100px', textAlign: 'right' }}>
                            Arvonlisäveroton hinta yhteensä
                          </th>
                          <th style={{ width: '100px', textAlign: 'right' }}>
                            Arvonlisävero yhteensä
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td />
                          <td style={{ textAlign: 'right' }}>
                            {getIsFinal() && -getWithOutVatFinal()}
                            {getIsAdvance() && -getWithOutVatAdvance()}
                          </td>
                          <td style={{ textAlign: 'right' }}>
                            {getIsFinal() && -getVatFinal()}
                            {getIsAdvance() && -getVatAdvance()}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
          {/* Payment Info */}
          <table>
            <tbody>
              <tr style={{ border: 'solid' }}>
                <th style={{ border: 'solid' }}>
                  <span
                    style={{
                      display: 'block',
                      textAlign: 'left',
                      verticalAlign: 'top',
                    }}
                  >
                    Viitenumero
                  </span>
                  <span
                    style={{
                      display: 'block',
                      textAlign: 'right',
                      verticalAlign: 'center',
                    }}
                  >
                    {invoiceData.referenceNumber}
                  </span>
                </th>
                <th style={{ border: 'solid' }}>HYVITYSLASKU EUR</th>
                <th style={{ border: 'solid' }}>
                  <strong>
                    {getIsFinal() && -bookingData.finalBillPrice}
                    {getIsAdvance() && -bookingData.advanceBillPrice}
                  </strong>
                </th>
              </tr>
            </tbody>
          </table>
          <section className="payment-info" style={{ marginTop: '40px' }}>
            {params.copy === 'true' && (
              <div>
                <div style={{ textAlign: 'left', marginTop: '8px' }}>
                  <strong>Omistajan alv-tiedot</strong>
                </div>
                <table style={{ borderTop: 'solid', borderBottom: 'solid' }}>
                  vatLinesOwner
                </table>
              </div>
            )}
            {params.copy === 'true' && (
              <div>
                <div style={{ textAlign: 'left', marginTop: '8px' }}>
                  <strong>Huoltajat</strong>
                </div>
                <table style={{ borderTop: 'solid', borderBottom: 'solid' }}>
                  {params.copy === 'true' && linesCareTaker}
                </table>
              </div>
            )}
          </section>
          <section className="payment-info" style={{ marginTop: '40px' }}>
            {bookingData.officerBookingNotes.map(note => (
              <strong>{note.noteText}</strong>
            ))}
          </section>
        </div>
      </div>
    </div>
  );
}
export default BookingCompensationInvoice;
